import React from "react";


const Topbar = () => {
    return(<>
    <div class="top-bar d-none d-md-block">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <div class="top-bar-left">
            <div class="text">
              <h2>8:00 - 9:00</h2>
              <p>Opening Hour Mon - Fri</p>
            </div>
            <div class="text">
              <h2>+44 7933 752257</h2>
              <p>Call Us For Appointment</p>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="top-bar-right">
            <div class="social">
              <a href="">
                <i class="fab fa-facebook-f"></i>
              </a>
            
              <a href="">
                <i class="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</>);
}

export default Topbar;